module.exports = __webpack_public_path__ + "static/media/signal-2.c2893c77.svg";